import createPersistedState from 'vuex-persistedstate'

const customStorage = {
  getItem: key => {
    if (process.client) {
      const data = window.localStorage.getItem(key)
      if (data) {
        const { value, timestamp } = JSON.parse(data)
        // Verificar si han pasado más de 30 minutos
        if (Date.now() - timestamp > 30 * 60 * 1000) {
          window.localStorage.removeItem(key)
          return null
        }
        return JSON.stringify(value)
      }
      return null
    }
  },
  setItem: (key, value) => {
    if (process.client) {
      const data = {
        value: JSON.parse(value),
        timestamp: Date.now()
      }
      window.localStorage.setItem(key, JSON.stringify(data))
    }
  },
  removeItem: key => {
    if (process.client) {
      window.localStorage.removeItem(key)
    }
  }
}

export default ({ store }) => {
  if (process.client) {
    createPersistedState({
      key: 'lesdixvins-blog',
      paths: [
        'blog.blogs',
        'blog.filters',
        'blog.currentBlog',
        'blog.totalResults',
        'blog.currentPage',
        'profile.getAllRegions',
        'profile.getDistricts'
      ],
      storage: customStorage,
      fetchBeforeUse: true
    })(store)
  }
} 
